/**
 * @author: ritesh.dabral
 * 
 * Hotspot edit config page
 */


// Slider Const 
export const sliderSettings = {
        infinite: false,
        slidesToShow:1,
        slidesToScroll: 1,
        swipeToSlide: false,
        autoplay: false,
        draggable: false,
        speed: 100,
        responsive: [
            {
              breakpoint: 1024,
              sliderSettings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                draggable: false
              }
            },
            {
              breakpoint: 600,
              sliderSettings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: false
              }
            },
            {
              breakpoint: 320,
              sliderSettings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: false
              }
            }
          ],
          nextArrow:'',
          prevArrow : ''
        }; 
//End Slider


export const typeOfHotspot = [
  {
    type:'Info',
    imgSrc: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/hotspot-info.png`,
  },
  {
    type:'Alert',
    imgSrc: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/hotspot-alert.png`
  },
  {
    type:'Favourite',
    imgSrc: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/hotspot-favorite.png`
  },
  {
    type:'Feature',
    imgSrc: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/hotspot-plus.png`
  },
]


export const URLvalidatorOptions = { 
  protocols: ['http','https','ftp'], 
  require_tld: true, 
  require_protocol: true, 
  require_host: true, 
  require_port: false, 
  require_valid_protocol: true, 
  allow_underscores: false, 
  host_whitelist: false, 
  host_blacklist: false, 
  allow_trailing_dot: false, 
  allow_protocol_relative_urls: false, 
  allow_fragments: true, 
  allow_query_components: true, 
  disallow_auth: false, 
  validate_length: true 
}